import React, { useState } from 'react';
import {
  Modal,
} from 'antd';
import {
  ExclamationCircleOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';


export const CustomAlertModal = (props) => {

  const defaultModalClass = "with-forced-icon";

  const [title, setTitle] = useState(null);
  const [modalClass, setModalClass] = useState(defaultModalClass);

  const IconByType = () => {
    switch (props.type) {
      case 'info':
        setTitle("Info");
        setModalClass(defaultModalClass);
        return (<ExclamationCircleOutlined />);
      case 'confirm':
        setTitle("Confirm");
        setModalClass(defaultModalClass + " icon-on-right");
        return (<QuestionCircleOutlined />);
    }
  }

  return (
    <div key={("modal-alert" + Math.floor(Math.random() * 16) + 5) }>
      <Modal
        title={title}
        className={modalClass}
        visible={props.visible}
        onCancel={props.onCancel}
        destroyOnClose={props.destroyOnClose}
        footer={props.footer}
      >
        <span className="modal-forced-icon"><IconByType /></span>
        <p dangerouslySetInnerHTML={{ __html: props.content } }></p>
      </Modal>
    </div>
    );
} 
